import MainLayout from './layouts/MainLayout.vue';
import List from './pages/List.vue';
import Add from './pages/Add.vue';
import Edit from './pages/Edit.vue';

export default {
  path: '/config',
  component: MainLayout,
  children: [{
    path: '',
    component: List,
    name: 'listOfConfig',
  }, {
    path: 'create',
    name: 'addConfig',
    component: Add,
  }, {
    path: ':id',
    component: Edit,
    props: true,
  }],
};
